export const getUniqueFromArray = (arr: any[], key?: string) =>
  Array.from(new Set(arr.map(arrItem => (key ? arrItem[key] : arrItem)))).map(id =>
    arr.find(arrItem => (key ? arrItem[key] : arrItem) === id)
  );
